import { useState, useEffect } from "react";
import { API } from "@/App";
import axios from "axios";
import { Lightbulb, Heart, Dumbbell, Utensils, Battery } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import Paywall from "@/components/Paywall";

const CAT_ICONS = { træningstip: Dumbbell, kost: Utensils, restitution: Battery, motivation: Heart };
const CAT_LABELS = { alle: "Alle", træningstip: "Træningstips", kost: "Kost", restitution: "Restitution", motivation: "Motivation" };
const CATEGORIES = ["alle", "træningstip", "kost", "restitution", "motivation"];

export default function Inspiration() {
  const [items, setItems] = useState([]);
  const [category, setCategory] = useState("alle");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const params = category !== "alle" ? { category } : {};
    axios.get(`${API}/inspiration`, { params })
      .then(res => setItems(res.data))
      .finally(() => setLoading(false));
  }, [category]);

  return (
    <Paywall>
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 animate-fade-in-up" data-testid="inspiration-page">
      <div className="flex items-center gap-3 mb-8">
        <Lightbulb className="h-6 w-6 text-[#DFFF00]" />
        <div>
          <h1 style={{ fontFamily: 'Oswald, sans-serif' }} className="font-bold text-2xl sm:text-3xl uppercase tracking-tight text-white">Inspiration</h1>
          <p className="text-sm text-zinc-400">Tips, motivation og ekspertviden</p>
        </div>
      </div>

      <div className="flex flex-wrap gap-2 mb-8">
        {CATEGORIES.map(cat => (
          <button key={cat} onClick={() => setCategory(cat)} data-testid={`inspiration-cat-${cat}`}
            className={`px-4 py-2 text-xs font-bold uppercase tracking-wider rounded-sm transition-all ${
              category === cat ? "bg-[#DFFF00] text-black" : "bg-zinc-900 text-zinc-400 hover:text-white border border-white/5"
            }`}>
            {CAT_LABELS[cat]}
          </button>
        ))}
      </div>

      {loading ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {[1,2,3].map(i => <div key={i} className="bg-[#18181b] border border-white/5 rounded-sm h-48 animate-pulse" />)}
        </div>
      ) : items.length === 0 ? (
        <div className="text-center py-16 text-zinc-500">Ingen inspiration fundet i denne kategori.</div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {items.map(item => {
            const Icon = CAT_ICONS[item.category] || Lightbulb;
            return (
              <Card key={item.id} className="bg-[#18181b] border-white/5 rounded-sm overflow-hidden hover:border-white/10 transition-all hover:-translate-y-1" data-testid={`inspiration-${item.id}`}>
                {item.image_url && (
                  <div className="h-40 overflow-hidden">
                    <img src={item.image_url} alt={item.title} className="w-full h-full object-cover opacity-70 hover:opacity-90 transition-opacity" />
                  </div>
                )}
                <CardContent className="p-5">
                  <div className="flex items-center gap-2 mb-3">
                    <Icon className="h-4 w-4 text-[#DFFF00]" />
                    <span className="text-[10px] uppercase tracking-wider text-zinc-500">{CAT_LABELS[item.category]}</span>
                  </div>
                  <h3 style={{ fontFamily: 'Oswald, sans-serif' }} className="font-bold text-base uppercase tracking-wide text-white mb-2">{item.title}</h3>
                  <p className="text-sm text-zinc-400 leading-relaxed">{item.content}</p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      )}
    </div>
    </Paywall>
  );
}
